module.exports = __webpack_public_path__ + "static/img/4.fc7b8b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/eng/4.png
// module id = jedN
// module chunks = 0